import { Handle, Position } from '@xyflow/react';

export default function PosNode({ data }) {
  const { pos } = data;
  const hasDiscrepancy = pos.discrepancies?.length > 0;
  const isClickable = pos.in_db === false;

  return (
    <div
      className={`px-3 py-2 rounded-lg border shadow min-w-[160px] transition-all ${isClickable ? 'cursor-pointer' : 'cursor-default'} ${
        !pos.in_db
          ? 'bg-amber-900/20 border-amber-500/50 hover:border-amber-400'
          : hasDiscrepancy
            ? 'bg-yellow-900/10 border-yellow-600/40 hover:border-yellow-400'
            : 'bg-bg-surface border-border hover:border-border-strong'
      }`}
    >
      <Handle type="target" position={Position.Top} className="!bg-slate-500" />
      <Handle type="source" position={Position.Bottom} className="!bg-slate-500" />
      <div className="flex items-center gap-1.5 mb-0.5">
        <span className="text-sm">🖥</span>
        <span className="text-xs font-medium text-slate-200 truncate max-w-[120px]">{pos.name}</span>
        {!pos.in_db && <span className="text-amber-400 text-sm ml-auto" title="Click para crear en tu sistema">⚠ click</span>}
      </div>
      <div className="text-xs text-slate-500 font-mono">{pos.external_id}</div>
      <div className="mt-1">
        {pos.mp_pos_id
          ? <span className="text-xs text-emerald-400">MP ✓</span>
          : <span className="text-xs text-amber-400">Sin sync</span>
        }
      </div>
    </div>
  );
}
